<template>
    <div style="display: flex; flex-direction: column; width: 100%;">
        <div style="display: flex; align-items: baseline; justify-content: space-between; width: 100%;">
            <div style="font-size: 11px; color: #5f5f5f;">{{ label }}</div>
            <div style="font-size: 12px; font-weight: 700; color: #b33700; white-space: nowrap; margin-left: 4px;">{{ valuePrefix }}{{ modelValue.min }} – {{ modelValue.max }}{{ valueSuffix }}</div>
        </div>

        <div class="threshold-range-track-wrapper">
            <div class="threshold-range-track"></div>
            <div class="threshold-range-highlight" :style="highlightStyle"></div>

            <input
                type="range"
                class="threshold-range-input"
                :class="{ 'is-active': activeThumb === 'min' }"
                :min="min"
                :max="max"
                :step="step"
                :value="modelValue.min"
                @input="handleMinInput"
                @mousedown="activeThumb = 'min'"
                @touchstart="activeThumb = 'min'"
            />

            <input
                type="range"
                class="threshold-range-input"
                :class="{ 'is-active': activeThumb === 'max' }"
                :min="min"
                :max="max"
                :step="step"
                :value="modelValue.max"
                @input="handleMaxInput"
                @mousedown="activeThumb = 'max'"
                @touchstart="activeThumb = 'max'"
            />
        </div>

        <div style="display: flex; justify-content: space-between; width: 100%; margin-top: 2px;">
            <div style="font-size: 10px; color: #acacac;">{{ min }}</div>
            <div style="font-size: 10px; color: #acacac;">{{ max }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ThresholdRangeSlider",

    props: {
        label: {
            type: String,
            default: "",
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 100,
        },
        step: {
            type: Number,
            default: 1,
        },
        modelValue: {
            type: Object,
            default: () => ({ min: 0, max: 100 }),
        },
        valuePrefix: {
            type: String,
            default: "",
        },
        valueSuffix: {
            type: String,
            default: "",
        },
    },

    emits: ["update:modelValue"],

    data() {
        return {
            activeThumb: null,
        };
    },

    computed: {
        highlightStyle() {
            const range = this.max - this.min || 1;
            const left = ((this.modelValue.min - this.min) / range) * 100;
            const right = ((this.modelValue.max - this.min) / range) * 100;
            return {
                left: `${left}%`,
                width: `${Math.max(0, right - left)}%`,
            };
        },
    },

    methods: {
        handleMinInput(event) {
            const value = Math.min(Number(event.target.value), this.modelValue.max);
            this.$emit("update:modelValue", { ...this.modelValue, min: value });
        },
        handleMaxInput(event) {
            const value = Math.max(Number(event.target.value), this.modelValue.min);
            this.$emit("update:modelValue", { ...this.modelValue, max: value });
        },
    },
};
</script>

<style scoped>
.threshold-range-track-wrapper {
    position: relative;
    width: 100%;
    height: 4px;
    margin: 10px 0 4px 0;
}

.threshold-range-track {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 4px;
    border-radius: 2px;
    background: #e3d5cc;
    transform: translateY(-50%);
}

.threshold-range-highlight {
    position: absolute;
    top: 50%;
    height: 4px;
    border-radius: 2px;
    background: #ff4e00;
    transform: translateY(-50%);
}

.threshold-range-input {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 0;
    margin: 0;
    transform: translateY(-50%);
    background: transparent;
    pointer-events: none;
    -webkit-appearance: none;
    appearance: none;
    z-index: 1;
}

.threshold-range-input.is-active {
    z-index: 2;
}

.threshold-range-input::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    background: transparent;
}

.threshold-range-input::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ff4e00;
    border: none;
    cursor: pointer;
    pointer-events: auto;
}

.threshold-range-input::-moz-range-track {
    background: transparent;
    border: none;
}

.threshold-range-input::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ff4e00;
    border: none;
    cursor: pointer;
    pointer-events: auto;
}
</style>
